<h1 mat-dialog-title cdkDrag cdkDragRootElement='.cdk-overlay-pane'
    cdkDragHandle>{{rabatkampagne.id ? "Rediger" : "Opret"}} rabatkampagne</h1>
<button class='btn-close btn-icon' mat-dialog-close title='Luk dialog'>
  <mat-icon class='material-icons'>close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]='form' autocomplete='off'>
    <div class='form-row'>
      <mat-form-field appearance='outline'>
        <mat-label>Navn</mat-label>
        <input formControlName='name' matInput />
      </mat-form-field>
    </div>
    <div class='form-row'>
      <app-rabat-form
        [rabatForm]='form'
        [isPrivatKunde]
        class='margin-top'
      ></app-rabat-form>
    </div>
    <div class='form-row'>
      <h2 class='form-headline margin--bottom-s margin--top-l'>Gyldighed</h2>
      <div class='flex margin--bottom-l'>
        <div class='form-row form-row--inline'>
          <mat-form-field appearance='outline'>
            <mat-label>Fra</mat-label>
            <mat-datepicker-toggle matPrefix [for]='validFromPicker'></mat-datepicker-toggle>
            <input #validFromInput matInput [matDatepicker]='validFromPicker' formControlName='validFrom' />
            <mat-datepicker #validFromPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class='form-row form-row--inline'>
          <mat-form-field appearance='outline'>
            <mat-label>Til</mat-label>
            <mat-datepicker-toggle matPrefix [for]='validToPicker'></mat-datepicker-toggle>
            <input #validToInput matInput [matDatepicker]='validToPicker' formControlName='validTo' />
            <mat-datepicker #validToPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close=''>Fortryd</button>
  <button [disabled]='!form.valid' mat-raised-button color='primary' (click)='update()'>Gem</button>
</div>
